// extracted by mini-css-extract-plugin
export default {"Badge":"Badge_Badge__LK6U9","label":"Badge_label__34u+s"};